module.exports = __webpack_public_path__ + "static/matza_4@1x-a10b5a20a4d5f9321e18e53ff8944e54.jpg";